import BaseCollection from "lib/collection";
import Entry from "models/catalog/entry";
import SchemaModel from "models/schema";
import { getStore } from "store";

const schemaCache = {};

export default BaseCollection.extend({
    mainIndex: "id",

    url() {
        return `/api/v3.1/catalog/${this.parent.id}/entries`;
    },

    model(attrs, options = {}) {
        const Model = options.collection ? options.collection.getSchemaModel(attrs) : Entry;
        return new Model(attrs, options);
    },

    getSchemaModel: function (attrs) {
        if (attrs.item) {
            let Model = schemaCache[attrs.item.__schema_id];
            if (Model) {
                return Model;
            }

            const { schemas } = getStore().getState().entities;
            const schemaRecord = schemas[attrs.item.__schema_id] && schemas[attrs.item.__schema_id].toJS();

            if (schemaRecord) {
                const schema = new SchemaModel(schemaRecord);

                Model = Entry.extend({
                    children: {
                        item: schema.getModel(),
                    },
                });
            } else {
                Model = Entry;
            }

            schemaCache[attrs.item.__schema_id] = Model;
            return Model;
        }
        return Entry;
    },

    isModel: function (model) {
        return model instanceof this.getSchemaModel(model);
    },
});
